import type { ReactNode } from 'react';
import { cx } from '@/styled-system/css';
import { useDetailPanel } from './DetailPanelContext';
import { DetailPanelHeader } from './DetailPanelHeader';
import * as styles from './detailPanel.styles';

type DetailPanelOutletProps = {
  headerActions?: ReactNode;
};

export const DetailPanelOutlet = ({ headerActions }: DetailPanelOutletProps) => {
  const { activeContent: Content, activeProvider: Provider, panelConfig, closePanel } = useDetailPanel();
  const isOpen = Content !== null;

  const renderContent = () => {
    if (!Content) return null;

    const body = <Content config={panelConfig} />;

    if (Provider) {
      return <Provider>{body}</Provider>;
    }

    return body;
  };

  return (
    <div
      className={cx(styles.panelOutlet, isOpen ? styles.panelOutletVisible : styles.panelOutletHidden)}
      aria-hidden={!isOpen}
      data-testid="detail-panel-outlet"
    >
      <DetailPanelHeader onClose={closePanel} actions={headerActions} />
      <div className={styles.panelBody}>{renderContent()}</div>
    </div>
  );
};

export type { DetailPanelOutletProps };
